<img [src]="badgeImage" [ngStyle]="{filter: 'url(#cf'+badge._id+')'}"/><color-filter [id]="'cf'+badge._id" [color]="badge.color"></color-filter>